import { useState } from 'react';
import { useGetLmsDashboardUpcomingTrainingsQuery } from '../../../../api';

const useLmsUpcomingTrainings = () => {
    const [lazyParams, setLazyParams] = useState({ first: 0, rows: 5, page: 1 });

    const { data, isLoading, isFetching } = useGetLmsDashboardUpcomingTrainingsQuery({ pageNumber: lazyParams.page, pageSize: lazyParams.rows }, { refetchOnMountOrArgChange: true });

    const onPage = (event) => {
        setLazyParams({ first: event.first, rows: event.rows, page: event.page + 1 });
    };

    return { items: data?.items || [], totalCount: data?.totalCount || 0, isLoading: isLoading || isFetching, lazyParams, onPage };
};

export default useLmsUpcomingTrainings;
